export default __webpack_public_path__ + "static/media/Boots of the Invincible.eb5e3b6e.jpg";